<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Document</div>
      <div class="modal-body" *ngIf="formGroup">
        <frg-form-input
          id="documentName"
          type="text"
          label="Titre"
          [formGroup]="formGroup"
          [control]="formGroup.get('documentName')"
        ></frg-form-input>
        <frg-form-input
          id="documentAuthor"
          type="text"
          label="Auteur"
          [formGroup]="formGroup"
          [control]="formGroup.get('documentAuthor')"
        ></frg-form-input>
      </div>
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="validForm()" [disabled]="!formGroup.valid">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>